/** String values must match FoodStorm.Contracts.OrderChannel. */
export enum OrderChannel {
  KdsOrderEntry = 'KdsOrderEntry',
  Kiosk = 'Kiosk',
}
